<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      {{titolo}}
    </div>
  </mat-card-title>
  <mat-card-content>

      <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Cognome Nome:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.Cognome}} {{obj?.Nome}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Codice Fiscale:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{objdettaglio?.CodiceFiscale}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Data Richiesta:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.DataRichiesta | date: 'dd/MM/yyyy' }}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Descrizione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.Descrizione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Stato Approvazione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.DescrizioneStatoApprovazione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Tipo Adesione:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.DescrizioneTipoAdesione}}
      </div>
    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Tipologia Richiesta:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.DescrizioneTipologiaRichiesta}}
      </div>

    </div>

    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Importo:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.Importo}} €
      </div>
    </div>



    <div fxLayout="row wrap" fxLayout.xs="column">
      <div fxFlex="30%;" fxFlex.xs="100%">
        <label><b>Periodo:</b> </label>
      </div>
      <div fxFlex="70%;" fxFlex.xs="100%">
        {{obj?.Periodo}}
      </div>
    </div>

  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

  <ngx-datatable #grdElencoNominativi
                 [rows]="lstElencoNominativi"
                 [columnMode]="'flex'"
                 [headerHeight]="50"
                 [footerHeight]="50"
                 [limit]="30"
                 [rowHeight]="'auto'">


    <ngx-datatable-column name="Cognome Nome"
                          [flexGrow]="2"
                          [sortable]="true"
                          prop="Cognome">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.Cognome }} {{ row?.Nome }}  {{ row?.Email }}
      </ng-template>
    </ngx-datatable-column>

   

    <ngx-datatable-column name="Codice Fiscale"
                          [flexGrow]="1.5"
                          [sortable]="true"
                          prop="CodiceFiscale">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{ row?.CodiceFiscale }}
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>



  <div mat-dialog-actions>
    <button mat-raised-button color="primary"
            (click)="btnAnnulla()">
      Indietro
    </button>

  </div>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>
